module.exports = __webpack_public_path__ + "media/images/signage-logo-30fbc8f21171c9f2e72c7e2025781013.svg";